var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"separator-container"},[_c('p',{staticClass:"separator-title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"separator-line"})])
}
var staticRenderFns = []

export { render, staticRenderFns }